import React from "react";
import { FullscreenFallback } from "../DialogComponents/DialogFallback/FullscreenFallback";
import { useContext } from "./hooks/useContext";

export const UploadData = () => {
  const context = useContext();

  return <FullscreenFallback context={context} />;
};
